import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function SolarBatteriesPage() {
  const serviceData = {
    title: 'Solar & Battery Systems',
    subtitle: 'Sustainable Energy Solutions',
    description: 'Maximize your solar investment with professional battery storage installation. Store excess solar energy for use during peak times or power outages. Our expert electricians design and install complete solar and battery systems tailored to your energy needs.',
    heroImage: 'https://public.readdy.ai/ai/img_res/b293b7cd61206029d8fd00a2882f2514.jpg',
    features: [
      {
        icon: 'ri-battery-charge-line',
        title: 'Battery Storage',
        description: 'Store solar energy for later use'
      },
      {
        icon: 'ri-sun-line',
        title: 'Solar Integration',
        description: 'Seamless connection with existing solar'
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Cost Savings',
        description: 'Reduce electricity bills significantly'
      },
      {
        icon: 'ri-flashlight-line',
        title: 'Backup Power',
        description: 'Power during outages and blackouts'
      }
    ],
    benefits: [
      'Battery storage installation',
      'Solar panel system installation',
      'Hybrid inverter upgrades',
      'Energy monitoring systems',
      'Grid connection services',
      'Backup power solutions',
      'System optimization',
      'Government rebate assistance'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Energy Assessment',
        description: 'Analyze your energy usage and solar potential'
      },
      {
        number: '02',
        title: 'System Design',
        description: 'Design optimal solar and battery solution'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Professional installation and grid connection'
      },
      {
        number: '04',
        title: 'Monitoring Setup',
        description: 'Configure monitoring and demonstrate system'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}